import { FieldValues } from 'react-hook-form'
import { TextInput as TextInputProps } from 'types/input'

const DateTime = <T extends FieldValues>({
  label,
  register,
  name,
  required,
  error,
  className,
  disabled = false,
  parentClassName,
  hintText,
  ...props
}: TextInputProps<T>) => {
  const hookFormRegister = register &&
    name && {
      ...register(name),
    }
  return (
    <div className="relative h-full w-full">
      {/* Label */}
      {label && (
        <label
          htmlFor={name}
          className="text-xs font-semibold text-sidebar-primary"
        >
          {label}
          {required && <span className="text-error">*</span>}
        </label>
      )}
      <div
        className={`mt-1 flex h-11 w-full gap-2 rounded-lg border 
       ${error ? 'border-error' : 'border-gray-300'}  px-3 focus:border-2 ${
         disabled ? 'cursor-not-allowed bg-gray-200' : 'bg-white'
       } ${parentClassName}`}
      >
        <input
          type="date"
          className={`h-full w-full bg-white text-sm text-primary  focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-600 ${className}`}
          disabled={disabled}
          {...props}
          {...hookFormRegister}
        />
      </div>

      {/* error or Input text */}
      {error ? (
        <p className="mt-1 text-xs text-error">{error}</p>
      ) : (
        <p className="mt-1 px-3 text-[11px] text-gray-500">{hintText}</p>
      )}
    </div>
  )
}

export default DateTime
